/**
 * Maximum allowed duration in seconds.
 * This is the maximum value the user can enter in the "Total" field.
 */
export const MAX_DURATION_SECONDS = 999 * 3600; // 999:00:00
